module.exports = __webpack_public_path__ + "media/images/app/trust/iconFour-9f8150aab6b0382776a088515a64893f.webp";